import { createFileRoute } from "@tanstack/react-router";
import Sell from "@/pages/Sell";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/sell/")({
  head: () => routeHead("/uk/sell/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Sell />
  );
}
